import { TableColumn } from '../../types/account';

export const getTableColumns = (t: any): TableColumn[] => [
  {
    key: 'account',
    name: t('labels.account'),
    sortable: false,
  },
  {
    key: 'revshare',
    name: t('labels.campaignsRevshare'),
    sortable: false,
  },
  {
    key: 'cpl',
    name: t('labels.campaignsCpl'),
    sortable: false,
  },
  {
    key: 'created',
    name: t('labels.added'),
    sortable: true,
    sortKey: 'created_at',
  },
  {
    key: 'actions',
    name: t('labels.actions'),
    sortable: false,
  },
];
